// BY LOF — global scripts
(function () {
  // ---- Mobile nav toggle ----
  var toggle = document.querySelector('[data-nav-toggle]');
  var nav = document.querySelector('[data-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }
  // ---- Submenu tap toggle (mobile) ----
  var submenuToggles = document.querySelectorAll('[data-submenu-toggle]');
  Array.prototype.forEach.call(submenuToggles, function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('[data-submenu]');
      var open = item.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });
  // ---- Footer collapsible groups ----
  var footerToggles = document.querySelectorAll('[data-footer-toggle]');
  Array.prototype.forEach.call(footerToggles, function (btn) {
    btn.addEventListener('click', function () {
      var group = btn.closest('[data-footer-group]');
      var open = group.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });
  // ---- Product variant selector (separated options) ----
  var form = document.querySelector('[data-product-form]');
  var dataEl = document.querySelector('[data-variant-json]');
  if (form && dataEl) {
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; }

    var idInput = form.querySelector('[data-variant-id]');
    var priceEl = document.querySelector('[data-current-price]');
    var compareEl = document.querySelector('[data-compare-price]');
    var addBtn = form.querySelector('[data-add-button]');
    var groups = Array.prototype.slice.call(form.querySelectorAll('.option-group'));

    // Read the currently-selected value for each option position, in order.
    function selectedOptions() {
      return groups.map(function (group) {
        var checked = group.querySelector('.swatch-input:checked');
        return checked ? checked.value : null;
      });
    }

    // Find the variant whose options array matches the given selection exactly.
    function matchVariant(selection) {
      return variants.find(function (variant) {
        return variant.options.length === selection.length &&
          variant.options.every(function (opt, i) { return opt === selection[i]; });
      });
    }

    // Grey out any value that, combined with the other current picks, has no
    // available variant — so you can't land on an impossible combination.
    function refreshAvailability() {
      var current = selectedOptions();
      groups.forEach(function (group, groupIndex) {
        var inputs = group.querySelectorAll('.swatch-input');
        Array.prototype.forEach.call(inputs, function (input) {
          var trial = current.slice();
          trial[groupIndex] = input.value;
          var match = variants.find(function (variant) {
            return variant.options.every(function (opt, i) {
              return trial[i] == null || opt === trial[i];
            }) && variant.available;
          });
          input.closest('.swatch').classList.toggle('is-unavailable', !match);
        });
      });
    }

    function update() {
      var variant = matchVariant(selectedOptions());
      if (idInput && variant) idInput.value = variant.id;

      if (variant) {
        if (priceEl) priceEl.textContent = variant.price;
        if (compareEl) {
          if (variant.compare_at_price) {
            compareEl.textContent = variant.compare_at_price;
            compareEl.hidden = false;
          } else {
            compareEl.hidden = true;
          }
        }
        if (addBtn) {
          addBtn.disabled = !variant.available;
          addBtn.textContent = variant.available ? 'Add to cart' : 'Sold out';
        }
      } else if (addBtn) {
        // No such combination exists at all.
        addBtn.disabled = true;
        addBtn.textContent = 'Unavailable';
      }
      refreshAvailability();
    }

    form.addEventListener('change', function (e) {
      if (e.target && e.target.classList.contains('swatch-input')) update();
    });

    refreshAvailability();
  }
})();